import type { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  /** Optional secondary text rendered below the title as muted lede. */
  lede?: ReactNode;
  /** Right-aligned actions (buttons, selects, stat cards, etc.). */
  actions?: ReactNode;
  /** Extra class name appended to the root. */
  className?: string;
}

/**
 * Canonical page header used across the app. Enforces identical title
 * typography, spacing under the TopBar, and actions alignment — so every page
 * lines up visually regardless of its content.
 *
 * Design rule: NO eyebrow / mini pill above the title. Every page is just
 * `TITLE — optional lede — optional actions`. Consistency over flourish.
 */
export function PageHeader({ title, lede, actions, className }: PageHeaderProps) {
  return (
    <div
      className={`page-header page-header--tight${className ? " " + className : ""}`}
    >
      <div className="page-header__text">
        <h1 className="page-header__title">{title}</h1>
        {lede ? <p className="page-header__lede">{lede}</p> : null}
      </div>
      {actions ? <div className="page-header__actions">{actions}</div> : null}
    </div>
  );
}
